import styled from 'styled-components';
import { Text } from '~/components/ui/Text';
import descBg from '../../assets/images/desc_bg.svg';
import imageBg from '../../assets/images/stage_bg.png';

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 40px;
`;

const StyledTopContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
`;

const StyledDescContainer = styled.div`
	height: 150px;
	padding: 20px;
	background-image: url(${descBg});
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	background-color: rgba(255, 255, 255, 0.02);
	border-radius: 10px;
	overflow: hidden;

	${Text} {
		font-weight: 400;
		font-size: 16px;
		color: #ffffff;
		opacity: 0.75;
	}
`;

const StyledStagesContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 9px;
`;

const StyledStageItem = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	height: 170px;
	padding: 20px;
	border-radius: 10px;
	border: 1px solid rgba(250, 192, 44, 0.5);
	overflow: hidden;
	background: rgba(250, 190, 44, 0.25);

	& > ${Text} {
		position: relative;
		z-index: 2;
		font-weight: 500;
		font-size: 14px;
		text-align: center;
		color: #fabe2c;
	}

	.number {
		position: relative;
		z-index: 2;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 20px;
		height: 20px;
		background-color: #fabe2c;
		border-radius: 5px;

		& > ${Text} {
			font-weight: 700;
			font-size: 14px;
			color: #000000;
		}
	}
`;

const StyledImageBg = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 1;
	background-image: url(${imageBg});
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	mask-image: linear-gradient(180deg, #ffffff 0%, rgba(255, 255, 255, 0) 70%);
	-webkit-mask-image: linear-gradient(
		180deg,
		#ffffff 0%,
		rgba(255, 255, 255, 0) 70%
	);
`;

const StyledAboutContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
`;

const StyledAboutGrid = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-auto-rows: 150px;
	gap: 20px;
`;

const StyledButtonContent = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 20px;

	img {
		width: 10px;
		height: 16px;
	}
`;

export {
	StyledAboutContainer,
	StyledAboutGrid,
	StyledButtonContent,
	StyledContainer,
	StyledDescContainer,
	StyledImageBg,
	StyledStageItem,
	StyledStagesContainer,
	StyledTopContainer,
};
